import { State, StateContext } from '../base/state';
import { stateTypes } from '../constants';

export class Context extends StateContext {
  constructor(controller) {
    super({
      controller,
      InitialInstance: InitialState,
      eventType: stateTypes.address,
    });
  }
}

export class InitialState extends State {
  constructor() {
    super({ status: 'idle' });
  }
}

export class LoadingState extends State {
  constructor() {
    super({ status: 'loading' });
  }
}

export class ErrorState extends State {
  constructor() {
    super({
      status: 'error',
      message: 'Не удалось получить адрес',
    });
  }
}

export class SuccessState extends State {
  constructor(value) {
    super({ status: 'success', value });
  }
}
